import React from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import AddressContent from '../address-content'
import { Iconfont } from '../../../../../components/icon/iconfont'
import { BlackMask } from '../../../../../components/mask'
import BottomToTop from '../../../../../components/transitions/bottom-to-top'
import { FormattedMessage } from 'react-intl'


export const SelectedAddress = props => {
    useStyles(classes)
    const { address, onSelect } = props
    return <div className={classes.SelectedAddress} onClick={e => onSelect(address)}>
        <AddressContent address={address}/>
        <div className={classes.IconArea}>
            {
                address.isDefaultAddress && <Iconfont className={classes.Icon}>&#xe6f0;</Iconfont>
            }
        </div>
    </div>
}

export const AddressBook = props => {
    useStyles(classes)
    const {addresses, onAddAddress, onSelect} = props
    return <div className={classes.AddressBook}>
        {
            addresses?.map(address => <SelectedAddress onSelect={onSelect} key={address.id} address={address}/>)
        }

        <div className={classes.ShipToOhter}>
            <span onClick={e => onAddAddress()}>
                <FormattedMessage id="ship_to_different_address" defaultMessage="Ship to different shipping address"/>
            </span>
        </div>
    </div>
}


const WrappedEditor = props => {
    useStyles(classes)
	return <React.Fragment>
		<BottomToTop in={props.show} className={classes.AddressContainer}>
			<div>
                <div className={classes.Hd}>
                    <span className={classes.Title}>
                        <FormattedMessage id="address_book" defaultMessage="Address Book"/>
                    </span>
                    <Iconfont className={classes.Close} onClick={props.onClose}>&#xe7c9;</Iconfont>
                </div>
                <div className={classes.Bd}>
                    <AddressBook {...props} />
                </div>
			</div>
		</BottomToTop>
		{props.show && <BlackMask onClick={props.onClose} />}
	</React.Fragment>
}


export default props => {

	if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}